export default "__VITE_ASSET__fWkYK80R__"